import styled from '@emotion/styled'
import { Box, TextField, Chip } from '@mui/material'
import { colors } from '../../../../Themes/Colors'

export const SearchContainer = styled(Box)`
  background-color: ${colors.lightestGrey};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
`

export const SearchFieldsWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
`

export const SearchField = styled(TextField)`
  flex: 1;
  min-width: 200px;

  .MuiInputBase-root {
    background-color: ${colors.resiliaWhite};
  }
`

export const ActiveFiltersWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
`

export const FilterChip = styled(Chip)`
  background-color: ${colors.lightBlue};
  color: ${colors.darkBlue};

  .MuiChip-deleteIcon {
    color: ${colors.darkBlue};
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
`
